<div id="registration-request-page" class="container-expanded bg-registration-request">
    <div class="page-content section-profile">
        <!-- <app-page-title [pageTitle]="'page.registration-request.title' | translate">
        </app-page-title> -->
        <div class="row m--0">

            <div
                class="col-12 col-lg-6 col-lg-offset-6 column gap-16 align-items-center justify-centent-center bg-white">
                <mat-card class="p--24 form-cart mat-elevation-z0">
                    <mat-card-header>
                        <mat-card-title>{{'page.registration_request.title' | translate}}</mat-card-title>
                        <mat-card-subtitle
                            [innerHTML]="'page.registration_request.subtitle' | translate"></mat-card-subtitle>
                    </mat-card-header>
                <mat-card-content>
                <div class="actions">
                    <button class="fw p--24" mat-flat-button color="primary" (click)="submitForm()"
                        [disabled]="buttonDisabled">{{ 'Reinviami l\'e-mail' | translate }}</button>
                    <div *ngIf="buttonDisabled && expireTime">Puoi reinviare tra {{expireTime}} secondi</div>
                    <mat-divider class="mt--24 mb--8"></mat-divider>
                </div>
                <div>
                    <p class="hint">{{'page.registration_request.login' | translate}}</p>
                </div>
                <div class="actions">
                    <button class="fw p--24" mat-flat-button color="primary" (click)="goToLogin()"
                        >{{ 'Entra' | translate }}</button>
                        <mat-divider class="mt--24 mb--8"></mat-divider>
                </div>
                <div>
                    <p class="hint">{{'page.registration_request.reset_password' | translate}}</p>
                </div>
                <div class="actions">
                    <button class="fw p--24" mat-flat-button color="primary" (click)="resetPassword()"
                        >{{ 'page.registration_request.reset_password_link' | translate }}</button>
                        <mat-divider class="mt--24 mb--8"></mat-divider>
                </div>
            </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
</div>